<template>
  <div class="lazy-collapse">
    <div class="in-shrink-title" @click="handleCollapseToggle">
      <div class="in-flex text-one">{{ label }}</div>
      <van-icon v-show="isCollapse" name="arrow-up" />
      <van-icon v-show="!isCollapse" name="arrow-down" />
    </div>
    <div v-show="isCollapse" class="in-body">
      <div v-if="flag == 0">
        <van-loading type="spinner" style="padding: .64rem 0;" />
      </div>
      <slot v-if="flag == 1"></slot>
      <div v-if="flag == 2">
        <van-empty :imageSize="emptyImgSize" :description="emptyDesc" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: [String, Number],
      default: -1
    },
    label: {
      type: String,
      default: ''
    },
    flag: {
      type: Number,
      default: 2 // 0:加载中 1:加载完成且有数据 2:加载完成但为空状态
    },
    emptyImgSize: {
      type: Number,
      default: 120
    },
    emptyDesc: {
      type: String,
      default: '暂无数据~'
    }
  },
  data() {
    return {
      isCollapse: false
    };
  },
  methods: {
    handleCollapseToggle() {
      this.isCollapse = !this.isCollapse;
      if (this.isCollapse) {
        this.$emit('collapse', this.id);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.lazy-collapse{
  border-radius: .1rem;background: #fff;overflow: hidden;

  .in-shrink-title{
    display: flex;align-items: center;height: .88rem;padding: 0.2rem 0.32rem;font-size: .28rem;line-height: .48rem;

    .in-flex{
      flex: 1;margin-right: .2rem;text-align: left;
    }
  }

  .in-body{
    position: relative;padding: 0.2rem 0.32rem;

    &:before{
      content: "";display: block;position: absolute;width: 100%;height: 1px;top: 0;left: 0;background: #eee;
    }
  }
}
</style>
